<template>
  <div
    class="text-center confirm-wrap position-relative m-auto p-5 d-flex flex-column justify-center items-center"
  >
    <h1 v-if="title" class="title">{{ title }}</h1>

    <div
      class="d-flex flex-row align-items-center justify-content-center mt-6 row no-gutters mb-4"
    >
      <HeraFormBtn
        v-if="cancelButtonText !== false"
        class="  cancel-btn"
        :class="cancel"
        :disabled="isLoading"
        @click.prevent="$emit('cancel')"
      >
        {{
          cancelButtonText ||
            $t('_web_stage_start_modal_confirmation_cancel', 'Cancel')
        }}
      </HeraFormBtn>
      <div
        v-if="cancelButtonText !== false && confirmButtonText !== false"
        class="spacer mx-3 px-2 col-auto"
      ></div>
      <HeraFormBtn
        v-if="confirmButtonText !== false"
        class="confirm"
        :loading="isLoading"
        :disabled="confirmButtonDisabled || isLoading"
        @click.prevent="$emit('confirm')"
      >
        {{
          confirmButtonText ||
            $t('_web_stage_start_modal_confirmation_accept', 'Accept')
        }}
      </HeraFormBtn>
    </div>
  </div>
</template>

<script>
import HeraFormBtn from '@/components/atoms/HeraFormBtn';

import { prop } from '@/utils/factories';

export default {
  name: 'CancelSubscription',
  components: { HeraFormBtn },

  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cancel: prop(String),
  },
};
</script>

<style lang="scss">
.title {
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 30px;
}
.confirm {
  max-width: fit-content;
  background: transparent !important;
  color: #9d9cf7 !important;
  font-weight: 400 !important;
  button {
    max-width: 180px;
  }
}

.cancel-btn {
  background-color: #5a58f2 !important;
  border-radius: 5px !important;
  color: white !important;
  border-radius: 4px !important;
  font-weight: 400 !important;
  height: 36px !important;
  width: 100px !important;
}
.confirm-wrap {
  padding: 0px !important;
}
</style>
